import type { QuestionType } from '@voice2me/shared';

/**
 * The response-type words accepted in column 2 of an imported spreadsheet, and the internal
 * question type each maps to. Keys are already normalised (see {@link normaliseResponseType}),
 * so matching is case-insensitive and forgiving of stray spacing around "yes / no".
 */
const RESPONSE_TYPE_ALIASES: Record<string, QuestionType> = {
  'open text': 'open_text',
  text: 'open_text',
  'free text': 'open_text',
  'yes/no': 'boolean',
  yesno: 'boolean',
  boolean: 'boolean',
  scale: 'rating',
  rating: 'rating',
  'multiple choice': 'multiple_choice',
  'multi choice': 'multiple_choice',
};

/** The canonical spellings shown to the user in the format guide and in error messages. */
export const RESPONSE_TYPE_LABELS = ['Open Text', 'Yes/No', 'Scale', 'Multiple Choice'] as const;

/** Lower-cases, trims, and tidies whitespace (including around a slash) so "Yes / No" matches. */
function normaliseResponseType(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .replace(/\s*\/\s*/g, '/')
    .replace(/\s+/g, ' ');
}

/** Resolves a cell's text to a question type, or `null` when it isn't a recognised response type. */
export function matchResponseType(raw: string): QuestionType | null {
  return RESPONSE_TYPE_ALIASES[normaliseResponseType(raw)] ?? null;
}
